module.exports = __webpack_public_path__ + "static/media/material-folder.99a07e82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/material/material-folder.png
// module id = 1116
// module chunks = 110